module.exports = __webpack_public_path__ + "static/img/71.9a40218.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/71.png
// module id = dbVR
// module chunks = 1